module.exports = __webpack_public_path__ + "static/TiemposTextWeb-SemiboldItalic-6e4f2de5e9557aa6f49ba1b1a9d402f2.eot";